import { createAction, props } from '@ngrx/store';
const toggleLock = 'TOGGLE_LOCK';
export const toggleLockAction = createAction(toggleLock);
